import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';

const Metrics = () => {
  const theme = useTheme();

  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) {
      return;
    }
    setViewPortEntered(isVisible);
  };

  const getIcon = (iconName) => {
    const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };

    switch (iconName) {
      case 'LanguageIcon':
        return <LanguageIcon {...iconProps} />;
      case 'YouTubeIcon':
        return <YouTubeIcon {...iconProps} />;
      case 'TwitterIcon':
        return <TwitterIcon {...iconProps} />;
      case 'InstagramIcon':
        return <InstagramIcon {...iconProps} />;
      case 'OndemandVideoIcon':
        return <OndemandVideoIcon {...iconProps} />;
      case 'LiveTvIcon':
        return <LiveTvIcon {...iconProps} />;
      default:
        return <LanguageIcon {...iconProps} />;
    }
  };

  const metricsData = [
    {
      title: 500,
      label: 'Audiencia mensual en plataforma (crecimiento sostenido)',
      subtitle: 'Comunidad enfocada en bienestar y estilo de vida.',
      suffix: '+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 30000,
      label: 'Visitas mensuales del ecosistema TNO',
      subtitle: 'Web y editorial compartidos.',
      suffix: '+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 20,
      label: 'Episodios On-Demand disponibles',
      subtitle: 'Más de 20 episodios. Contenido acumulado del programa.',
      suffix: '+',
      icon: getIcon('OndemandVideoIcon'),
    },
    {
      title: 1,
      label: 'Emisión en vivo semanal',
      subtitle: 'Jueves 2:00 PM por TNO Network.',
      suffix: '',
      icon: getIcon('LiveTvIcon'),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'primary'}
          align={'center'}
        >
          Números
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          align={'center'}
          gutterBottom
          color={'primary'}
        >
          Los números de La Dosis Positiva
        </Box>
        <Typography
          variant={'h6'}
          align={'center'}
          color="textSecondary"
          sx={{ mb: 4 }}
        >
          Tu marca llega a una audiencia que valora el bienestar, la innovación y el crecimiento personal.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginBottom={2}
              >
                {item.icon}
              </Box>
              <Typography variant="h3" align={'center'} gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor
                    onChange={(isVisible) => setViewPortVisibility(isVisible)}
                    delayedCall
                  >
                    <CountUp
                      redraw={false}
                      end={viewPortEntered ? item.title : 0}
                      start={0}
                      suffix={item.suffix}
                    />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align={'center'} variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align={'center'} component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box maxWidth={700} margin={'0 auto'} position={'relative'}>
        <Box
          component={LazyLoadImage}
          height={'100%'}
          width={'100%'}
          src="/images/yanirabocarandaladosispositiva.jpeg"
          alt="Yanira Bocaranda - La Dosis Positiva"
          effect="blur"
          boxShadow={4}
          borderRadius={1.5}
        />
      </Box>
    </Box>
  );
};

export default Metrics;
